import { prisma } from "../../lib/prisma";
import config from "../../config";
import {
  ICreateCommentPayload,
  IModerateCommentPayload,
  IUpdateCommentPayload,
} from "./comment.interface";

const createComment = async (
  authorId: string,
  payload: ICreateCommentPayload,
) => {
  await prisma.post.findUniqueOrThrow({
    where: {
      id: payload.postId,
    },
  });
  const comment = await prisma.comment.create({
    data: {
      ...payload,
      authorId,
    },
  });
  return comment;
};

const getCommentByAuthorId = async (authorId: string) => {
  const comments = await prisma.comment.findMany({
    where: {
      authorId,
    },
    orderBy: {
      createdAt: "desc",
    },
    include: {
      post: {
        select: {
          id: true,
          title: true,
          views: true,
        },
      },
    },
  });
  return comments;
};

const getCommentByPostId = async (postId: string) => {
  const comments = await prisma.comment.findMany({
    where: {
      postId,
    },
  });
  return comments;
};

const updateComment = async (
  commentId: string,
  payload: IUpdateCommentPayload,
  authorId: string,
) => {
  const result = await prisma.comment.findUniqueOrThrow({
    where: {
      id: commentId,
      authorId,
    },
    select: {
      id: true,
    },
  });

  if (!result) {
    throw new Error("Comment not found or access denied");
  }
  const updatedComment = await prisma.comment.update({
    where: {
      id: commentId,
      authorId,
    },
    data: payload,
  });
  return updatedComment;
};

const deleteComment = async (commentId: string, authorId: string) => {
  const result = await prisma.comment.findFirst({
    where: {
      id: commentId,
      authorId,
    },
    select: {
      id: true,
    },
  });

  if (!result) {
    throw new Error("Comment not found or access denied");
  }
  await prisma.comment.delete({
    where: {
      id: commentId,
      authorId,
    },
  });
};

const moderateComment = async (
  id: string,
  payload: IModerateCommentPayload,
) => {
  const commentData = await prisma.comment.findUniqueOrThrow({
    where: {
      id,
    },
    select: {
      id: true,
      status: true,
    },
  });
  if (commentData.status === payload.status) {
    throw new Error(
      `Your provided status ${payload.status} is already up to date.`,
    );
  }

  const updatedModerateComment = await prisma.comment.update({
    where: {
      id,
    },
    data: payload,
  });
  return updatedModerateComment;
};

export const commentService = {
  createComment,
  getCommentByAuthorId,
  getCommentByPostId,
  updateComment,
  deleteComment,
  moderateComment,
};
